<template>
  <PageContainer title="Relatório financeiro" class="relatorios-container">
    <DropdownCard title="Recebimento">
      <CurrencyUsd slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="receipt in receipts" :key="receipt.title" :title="receipt.title"
          :description="receipt.description" @onAction="receipt.fn" />
      </div>
    </DropdownCard>

    <DropdownCard title="Faturamento">
      <CashMultiple slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="billing in billings" :key="billing.title" :title="billing.title"
          :description="billing.description" @onAction="billing.fn" />
      </div>
    </DropdownCard>

    <DropdownCard title="Outros">
      <ListBoxOutline slot="icon" />

      <div slot="body" class="dropdown-content">
        <RelatorioCard v-for="other in others" :key="other.title" :title="other.title" :description="other.description"
          @onAction="other.fn" />
      </div>
    </DropdownCard>

    <FaturasPagasModal ref="faturasPagasModal" />

    <FaturamentoModal ref="faturamentoModal" />
    <FaturamentoTipoStatusModal ref="faturamentoTipoStatusModal" />
    <FaturasPendentes ref="faturasPendentes" />
    <BoletosPagosModal ref="boletosPagosModal" />

    <DoacoesModal ref="doacoesModal" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import DropdownCard from 'core/DropdownCard'
import RelatorioCard from 'core/RelatorioCard'
import CurrencyUsd from 'icons/CurrencyUsd'
import CashMultiple from 'icons/CashMultiple'
import ListBoxOutline from 'icons/ListBoxOutline'
import FaturasPagasModal from './modal/FaturasPagasModal'
import DoacoesModal from './modal/DoacoesModal'
import FaturamentoModal from './modal/FaturamentoModal'
import FaturamentoTipoStatusModal from './modal/FaturamentoTipoStatusModal'
import FaturasPendentes from './modal/FaturasPendentes'
import BoletosPagosModal from './modal/BoletosPagosModal'

export default {
  name: 'relatorioAdmin',
  components: {
    PageContainer,
    DropdownCard,

    CurrencyUsd,
    CashMultiple,
    ListBoxOutline,

    RelatorioCard,
    FaturasPagasModal,
    DoacoesModal,
    FaturamentoModal,
    FaturamentoTipoStatusModal,
    FaturasPendentes,
    BoletosPagosModal,
  },
  data() {
    return {
      receipts: [
        {
          title: 'Faturas Pagas',
          description: 'Visualize aqui todas as faturas já quitadas, com detalhes de data, valor e forma de pagamento para sua conferência e controle financeiro.',
          fn: () => this.openModal('faturasPagasModal'),
        }
      ],
      billings: [
        {
          title: 'Faturamentos',
          description: 'Acompanhe o histórico completo de faturamentos com dados detalhados sobre receitas geradas e períodos correspondentes.',
          fn: () => this.openModal('faturamentoModal'),
        },
        {
          title: 'Faturamento por Tipo e Status',
          description: 'Veja a distribuição do faturamento categorizada por tipo de serviço e status de pagamento, facilitando o monitoramento e a análise financeira.',
          fn: () => this.openModal('faturamentoTipoStatusModal'),
        },
        {
          title: 'Faturas Pendentes por Quantidade de Aulas',
          description: 'Confira as faturas pendentes organizadas pela quantidade de aulas realizadas, ajudando a identificar débitos relacionados às atividades.',
          fn: () => this.openModal('faturasPendentes'),
        },
        {
          title: 'Boletos Pagos',
          description: 'Tenha acesso à lista de boletos pagos, com informações de confirmação de pagamento e detalhes da transação.',
          fn: () => this.openModal('boletosPagosModal'),
        },
      ],
      others: [
        {
          title: 'Doações',
          description: 'Acompanhe todas as contribuições recebidas, com detalhes de valores, datas e doadores, facilitando o controle e a transparência.',
          fn: () => this.openModal('doacoesModal'),
        }
      ],
    }
  },
  methods: {
    openModal(modal) {
      this.$refs[modal].open()
    }
  }
}
</script>

<style lang="scss" scoped>
.relatorios-container {
  .dropdown-content {
    padding: 1.5rem 2rem;

    display: flex;
    flex-direction: column;
    gap: 3rem;
  }
}
</style>
